import React, { FC, PropsWithChildren } from 'react';
import style from './DivAnimate.module.css';

// interface Props {}

export const DivAnimate: FC<PropsWithChildren> = ({ children }) => {
  return <div className={style.anim}>{children}</div>;
};
